export const generateBadge = (count) => {
    const canvas = document.createElement('canvas');
    canvas.width = 16;
    canvas.height = 16;
    const ctx = canvas.getContext('2d');
  
    // Draw circle
    ctx.beginPath();
    ctx.arc(8, 8, 8, 0, Math.PI * 2);
    // ctx.fillStyle = 'grey';
    ctx.fillStyle = 'black';
    ctx.fill();
  
    // Draw text
    ctx.fillStyle = 'white';
    ctx.font = 'bold 11px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(count > 99 ? '99+' : count.toString(), 8, 8);
  
    return canvas.toDataURL();
  };

